import React from "react";
import { DocumentFormat } from "../utils/documentFormats";
import { Select } from "@axa-fr/design-system-look-and-feel-react";

type Props = {
  formats: DocumentFormat[];
  selectedFormatValue: string | null;
  onChange: (value: string) => void;
};

const FormatSelector: React.FC<Props> = ({
  formats,
  selectedFormatValue,
  onChange,
}) => {
  if (!formats || formats.length === 0) return null;

  return (
    <Select
      id="format-selector"
      label=""
      options={formats.map((f) => ({ label: f.label, value: f.value }))}
      value={
        selectedFormatValue
          ? {
              label: formats.find((f) => f.value === selectedFormatValue)!
                .label,
              value: selectedFormatValue!,
            }
          : null
      }
      onChange={(option) => {
        if (option && typeof option === "object" && "value" in option) {
          onChange(String(option.value));
        }
      }}
    />
  );
};

export default FormatSelector;
